import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { Navigator } from 'src/app/services/routing/navigator'
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { distinctUntilChanged, filter, map } from 'rxjs';

@Component({
  selector: 'app-rewards-connect',
  templateUrl: './rewards-connect.page.html',
  styleUrls: ['./rewards-connect.page.scss'],
})
export class RewardsConnectPage implements OnInit {
  @Input() params = null;
  public infoForm: FormGroup;
  nextBtnText: string = "Next";
  public legalAge: number;
  public dateOfBirthGroup: AbstractControl;
  public dateOfBirthYear: AbstractControl;
  public dateOfBirthDay: AbstractControl;
  public dateOfBirthMonth: AbstractControl;
  public error = null;
  public reward_Connect_States = {
    linkCard: 'LINK_CARD_WINDOW',
    feedBack: 'FEEDBACK_WINDOW'
  }
  public isLoading: boolean = false;
  public buttonDisabled: boolean = false;
  public currentState = this.reward_Connect_States.linkCard;
  userDetails: { lastName: string; dob: Date; };
  constructor(private config: ConfigService, private boydRewardsService: BoydRewardsService, public navigator: Navigator,
    private userSessionService: UserSessionService
  ) {

    this.legalAge = this.config.getConfig().FEATURE_LEGAL_AGE || 21;

    this.infoForm = new FormGroup({
      reward_number: new FormControl('', [Validators.required]),
      lastName: new FormControl({ value: '', disabled: true }),
      dateOfBirthGroup: new FormGroup(
        {
          dateOfBirthYear: new FormControl({ value: '', disabled: true }),
          dateOfBirthDay: new FormControl({ value: '', disabled: true }),
          dateOfBirthMonth: new FormControl({ value: '', disabled: true }),
        },
      ),
    });

    this.dateOfBirthGroup = this.infoForm.get('dateOfBirthGroup');
    this.dateOfBirthYear = this.dateOfBirthGroup.get('dateOfBirthYear');
    this.dateOfBirthDay = this.dateOfBirthGroup.get('dateOfBirthDay');
    this.dateOfBirthMonth = this.dateOfBirthGroup.get('dateOfBirthMonth');
  }

  preFillUserObject(userDetails) {
    if (userDetails) {
      this.infoForm.get('lastName')?.setValue(userDetails?.lastName);
      if (userDetails?.dob) {
        const [year, month, day] = userDetails.dob.split('-');
        let index = parseInt(month, 10);
        this.dateOfBirthYear?.setValue(parseInt(year, 10));
        this.dateOfBirthMonth?.setValue(index);
        this.dateOfBirthDay?.setValue(day);
      }
    }
  }

  private getUser() {
    const userDetails = this.params ?? null;
    if(userDetails) {
      this.preFillUserObject(userDetails);
    } else {
      this.userSessionService.getCustomer().pipe(
        filter((userResponse) => !!userResponse),
        map(item => { return { lastName: item?.lastName, dob: item?.birthDate } }),
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
      ).subscribe((userResponse: any) => {
        this.preFillUserObject(userResponse);
      }).unsubscribe();
    }
  }

  get months() {
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if (this.dateOfBirthYear.value == this.years[0]) {
      let extra = 11 - new Date().getMonth();
      for (extra; extra > 0; extra--) {
        months.pop();
        if (this.dateOfBirthMonth.value == months.length + 1) this.dateOfBirthMonth.setValue(months.length)
      }
    }
    return months;
  }

  get days() {
    let days = Array.apply(null, { length: 31 }).map(Number.call, Number)
    let displayDays = days.map(val => val + 1).map(val => (val < 10) ? "0" + val.toString() : val.toString());
    if (
      this.dateOfBirthYear.value == this.years[0] &&
      this.dateOfBirthMonth.value - 1 == this.months.indexOf(this.months[this.months.length - 1])
    ) {
      let extra = 31 - new Date().getDate();
      for (extra; extra > 0; extra--) {
        displayDays.pop();
        if (this.dateOfBirthDay.value == displayDays.length + 1) this.dateOfBirthDay.setValue(displayDays[displayDays.length - 1]);
      }
    }
    return displayDays;
  }

  get years() {
    let years = [];
    var min = new Date().getFullYear() - 100,
      max = new Date().getFullYear() - this.legalAge;
    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years;
  }


  onSubmit() {
    this.buttonDisabled = true;
    this.isLoading = true;
    if (!this.infoForm.value) return;
    this.boydRewardsService.linkRewardCard(this.infoForm?.value?.reward_number).subscribe((val) => {
      this.buttonDisabled = false;
      this.currentState = this.reward_Connect_States.feedBack;
      this.stopLoader();
    }, (error) => {
      this.stopLoader();
      this.error = error;
      this.buttonDisabled = false;
      switch (error.getErrorCode().toUpperCase()) {
        case 'CUSTOMER_NOT_FOUND':
          error.setErrorMessage('Customer cannot be found');
          break;
        case 'CARD_ALREADY_EXISTS':
          error.setErrorMessage('Rewards Card already exists');
          break;
        default:
          error.setErrorMessage('Oops! We cannot confirm your account information');
          break;
      }
    });
  }

  clickCurrentStatus() {
    this.navigator.back();
  }

  ngOnInit() {
    this.getUser();
  }

  private stopLoader() {
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

}
